import React from 'react';
import { bool, func, shape } from 'prop-types';
import Carriers from '../../edit/Carriers';
import CarriersAccordion from '../../components/CarriersAccordion';

const CarriersTab = ({ customerAuth, setCustomerAuth, isEditMode }) => {
  return (
    <div>
      {isEditMode ? (
        <Carriers info={customerAuth} setInfo={setCustomerAuth} />
      ) : (
        <CarriersAccordion
          carriers={customerAuth.carriers || []}
          defaultExpanded
          isCarrierRestricted={customerAuth.isCarrierRestricted}
        />
      )}
    </div>
  );
};
CarriersTab.propTypes = {
  customerAuth: shape({}).isRequired,
  isEditMode: bool.isRequired,
  setCustomerAuth: func.isRequired,
};

export default CarriersTab;
